import { cn as e } from "../../lib/utils.es.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
// libs/ui-lib/src/components/ui/textarea.tsx
function n({ className: n, ...r }) {
	return /* @__PURE__ */ t("textarea", {
		"data-slot": "textarea",
		className: e("border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", n),
		...r
	});
}
export { n as Textarea };
